module.exports = __webpack_public_path__ + "img/gamifinnopolis-sport.85f1d68e.png";